import * as z from "zod";

export const qaMetricsReasonCountSchema = z.object({
  reason: z.string(),
  fails: z.number(),
});

export const qaMetricsProcessorRowSchema = z.object({
  name: z.string(),
  itemsProcessed: z.number(),
  fails: z.number(),
  dpmo: z.number().nullable(),
  aboveTarget: z.boolean(),
  reasons: z.array(qaMetricsReasonCountSchema),
});

export const qaMetricsDaySchema = z.object({
  date: z.string(),
  itemsProcessed: z.number(),
  fails: z.number(),
  dpmo: z.number(),
});

export const qaMetricsTotalsSchema = z.object({
  itemsProcessed: z.number(),
  processorCount: z.number(),
  fails: z.number(),
  dpmo: z.number().nullable(),
  topReason: z.string().nullable(),
});

export const getQaMetricsDashboard = {
  name: "getQaMetricsDashboard" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({
    dpmoTarget: z.number(),
    criteriaCount: z.number(),
    totals: qaMetricsTotalsSchema,
    failsByReason: z.array(qaMetricsReasonCountSchema),
    dpmoByDay: z.array(qaMetricsDaySchema),
    byProcessor: z.array(qaMetricsProcessorRowSchema),
    processorsTruncated: z.boolean(),
  }),
};

export type QaMetricsDashboard = z.infer<
  (typeof getQaMetricsDashboard)["output"]
>;
export type QaMetricsReasonCount = z.infer<typeof qaMetricsReasonCountSchema>;
export type QaMetricsProcessorRow = z.infer<typeof qaMetricsProcessorRowSchema>;
export type QaMetricsDay = z.infer<typeof qaMetricsDaySchema>;
